import axios from 'axios';
const api = axios.create({
    baseURL: 'https://api.docparser.com/v1'
})
const apiKey = process.env.VUE_APP_DOC_PARSER_API_KEY;

export const ping = () => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get(`/ping?api_key=${apiKey}`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});

export const getParsers = () => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get(`/parsers?api_key=${apiKey}`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});

export const getParsedDataByDocId = ({ parser_id, document_id }) => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get(`/results/${parser_id}/${document_id}?api_key=${apiKey}&include_children=true`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});

export const getParsedDataByRemoteId = ({ parser_id, remote_id }) => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get(`/results/${parser_id}?api_key=${apiKey}&include_processing_queue=true&remote_id=${remote_id}`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});

export const getAllParsedData = ({ parser_id }) => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get(`/results/${parser_id}?api_key=${apiKey}&include_processing_queue=true`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});

export const importDocumentByUrl = ({ parser_id, url, remote_id }) => new Promise(async(resolve, reject) => {
    try {
        let response = await api.post(`/document/fetch/${parser_id}?api_key=${apiKey}&url=${url}&remote_id=${remote_id}`);
        if(response.status === 200){
            resolve(response.data)
        }
    } catch (error) {
        reject(error)
    }
});